import React, { useState } from 'react';
import './App.css';
import HomePage from './homepage/HomePage';
import { Routes, Route } from 'react-router';
import Flight from './components/flights/Flight';
import Hotel from './components/hotels/Hotel';
import HomeStay from './components/homeStay/HomeStay';
import Holiday from './components/holiday/Holiday';
import Trains from './components/train/Trains';
import Buses from './components/bus/Buses';
import Cab from './components/cabs/Cabs';
import Forex from './components/forex/Forex';
import Charter from './components/charterFlight/Charter';
import { AuthContextProvider } from './components/login/userAuthContext';
import LoginPage from './components/login/Login';
import SignUp from './components/login/Signup';
import ProtectedRoute from './components/protectedRoute/ProtectedRoute';
import TicketPage from './components/ticketsPage/TicketPage';
import BookFlights from './components/flights/FlightTickets';
import { PricingContext } from './components/Payments/PricingContext';
import { PaymentContext } from './components/Payments/PaymentContext';
import PaymentProceed from './components/Payments/payment.js';
import BookBuses from './components/bus/BusTickets';
import BookCabs from './components/cabs/CabTickets';
import BookHomes from './components/homeStay/HomeTickets';
import BookHotels from './components/hotels/HotelTickets';
import BookTrains from './components/train/TrainTickets';
import { UsernameContext } from './components/login/usernameContext';
import Success from './components/Payments/paymentSuccess';
import { NavigatorContext } from './contexts/NavigatorContext';
import About from './components/about/About';
import FlightMobile from './components/flights/FlightMobile';
import HomepageMob from './homepage/HomepageMob';
import HotelMobile from './components/hotels/HotelMob';
import HomeStayMobile from './components/homeStay/HomeMob';
import HolidayMobile from './components/holiday/HolidayMob';
import TrainMobile from './components/train/TrainMobile';
import BusesMobile from './components/bus/BusesMobile';
import CabsMobile from './components/cabs/CabsMobile';
function App() {
  const [surcharge, setSurcharge] = useState(0);
  const [price, setPrice] = useState(0);
  const [username, setUsername] = useState("");
  const [param, setParam] = useState("flight");
  return (
    <div>
     <AuthContextProvider>
     <UsernameContext.Provider value={{username, setUsername}}>
      <NavigatorContext.Provider value={{param, setParam}}>
        <Routes>
          <Route path='/' element={<HomePage />}>
            <Route index element={<Flight />} />
            <Route path='/flights' element={<Flight />} />
            <Route path='/hotels' element={<Hotel />} />
            <Route path='/homes' element={<HomeStay />} />
            <Route path='/holidays' element={<Holiday />} />
            <Route path='/trains' element={<Trains />} />
            <Route path='/buses' element={<Buses />} />
            <Route path='/cabs' element={<Cab />} />
            <Route path='/forexs' element={<Forex />} />
            <Route path='/charters' element={<Charter />} />
          </Route>
          <Route path="/mob" element={<HomepageMob />}>
            <Route path="/mob/flight" element={<FlightMobile />} />
            <Route path='/mob/hotel' element={<HotelMobile />} />
            <Route path='/mob/home' element={<HomeStayMobile />} />
            <Route path='/mob/holiday' element={<HolidayMobile />} />
            <Route path='/mob/train' element={<TrainMobile />} />
            <Route path='/mob/bus' element={<BusesMobile />} />
            <Route path='/mob/cab' element={<CabsMobile />} />
          </Route>
          <Route path='/login' element={<LoginPage />} />
          <Route path='/signup' element={<SignUp />} />
          <Route path='/about' element={<About />} />
          <Route path='/tickets' element={<ProtectedRoute><TicketPage /></ProtectedRoute>}>
            <Route path='/tickets/flight' element={<PaymentContext.Provider value ={{setPrice, setSurcharge}}><BookFlights /></PaymentContext.Provider>} />
            <Route path='/tickets/bus' element={<PaymentContext.Provider value={{setPrice, setSurcharge}}><BookBuses /></PaymentContext.Provider>} />
            <Route path='/tickets/cab' element={<PaymentContext.Provider value={{setPrice, setSurcharge}}><BookCabs /></PaymentContext.Provider>} />
            <Route path='/tickets/holiday' element={<h2 style={{padding:'10px'}}>No tickets available now</h2>} />
            <Route path='/tickets/home' element={<PaymentContext.Provider value={{setPrice, setSurcharge}}><BookHomes /></PaymentContext.Provider>} />
            <Route path='/tickets/hotel' element={<PaymentContext.Provider value={{setPrice, setSurcharge}}><BookHotels /></PaymentContext.Provider>} />
            <Route path='/tickets/train' element={<PaymentContext.Provider value={{setPrice, setSurcharge}}><BookTrains /></PaymentContext.Provider>} />
          </Route>
          <Route path='/payments' element={<TicketPage />}>
            <Route index element={<PricingContext.Provider value={{price, surcharge}}><PaymentProceed /></PricingContext.Provider>} />
            <Route path='/payments/success' element={<Success />} />
          </Route>
        </Routes>
      </NavigatorContext.Provider>
     </UsernameContext.Provider>
     </AuthContextProvider>
    </div>
  );
}

export default App;
